import { create } from "zustand";
import { createUserSlice, UserSlice } from "./UserStore";
import { createWebDavSlice, WebDavSlice } from "./webDavStore";
import { createTextControlSlice, TextControlSlice } from "./textControlStore";
import { createMapViewSlice, MapViewSlice } from "./mapViewStore";
import { createGazetteerSlice, GazetteerSlice } from "./gazetteerStore";
import { createCurrentApplicationSlice, CurrentApplicationSlice } from "./currentApplicationStore";
import { createAdminPanelSlice, AdminPanelSlice } from "./adminPanelStore";
import { createActionDialogSlice, ActionDialogSlice, ActionDialogProps } from "./actionDialogStore";
import { createEarthlightMapViewSlice, EarthlightMapViewSlice } from "./earthlightMapViewStore";
import { createConfirmDialogSlice, ConfirmDialogSlice, ConfirmDialogProps } from "./confirmDialogStore";
import { createDashboardViewerSlice, DashboardViewerSlice } from "./dashboardViewerStore";
import { createDocumentPickerSlice, DocumentPickerSlice } from "./documentPickerStore";
import { createDocxPopupSlice, DocxPopupSlice } from "./docxPopupStore";
import { createFolderPickerSlice, FolderPickerSlice } from "./folderPickerStore";
import { createInformDialogSlice, InformDialogSlice, InformDialogManagerState } from "./informDialogStore";
import { createMirageDrawerSlice, MirageDrawerSlice } from "./mirageDrawerStore";
import { createMirageLoginSlice, MirageLoginSlice } from "./mirageLoginStore";
import { createSessionTimeoutSlice, SessionTimeoutSlice } from "./sessionTimeoutStore";
import { createCustomAlertSlice, CustomAlertSlice } from "./customAlertStore";
import { createImageViewerSlice, ImageViewerSlice } from "./imageViewerStore";
import { createPdfReaderSlice, PdfReaderSlice } from "./pdfReaderStore";
export type { ActionDialogProps, ConfirmDialogProps, InformDialogManagerState };

export const useUserStore = create<UserSlice>()((...a) => ({
    ...createUserSlice(...a),
}));

export const useWebDavStore = create<WebDavSlice>()((...a) => ({
    ...createWebDavSlice(...a),
}));

export const useTextControlStore = create<TextControlSlice>()((...a) => ({
    ...createTextControlSlice(...a),
}));

export const useMapViewStore = create<MapViewSlice>()((...a) => ({
    ...createMapViewSlice(...a),
}));

export const useGazetteerStore = create<GazetteerSlice>()((...a) => ({
    ...createGazetteerSlice(...a),
}));

export const useCurrentApplicationStore = create<CurrentApplicationSlice>()((...a) => ({
    ...createCurrentApplicationSlice(...a),
}));

export const useAdminPanelStore = create<AdminPanelSlice>()((...a) => ({
    ...createAdminPanelSlice(...a),
}));

export const useActionDialogStore = create<ActionDialogSlice>()((...a) => ({
    ...createActionDialogSlice(...a),
}));

export const useEarthlightMapViewStore = create<EarthlightMapViewSlice>()((...a) => ({
    ...createEarthlightMapViewSlice(...a),
}));

export const useConfirmDialogStore = create<ConfirmDialogSlice>()((...a) => ({
    ...createConfirmDialogSlice(...a),
}));

export const useDashboardViewerStore = create<DashboardViewerSlice>()((...a) => ({
    ...createDashboardViewerSlice(...a),
}));

export const useDocumentPickerStore = create<DocumentPickerSlice>()((...a) => ({
    ...createDocumentPickerSlice(...a),
}));

export const useDocxPopupStore = create<DocxPopupSlice>()((...a) => ({
    ...createDocxPopupSlice(...a),
}));

export const useFolderPickerStore = create<FolderPickerSlice>()((...a) => ({
    ...createFolderPickerSlice(...a),
}));

export const useInformDialogStore = create<InformDialogSlice>()((...a) => ({
    ...createInformDialogSlice(...a),
}));

export const useMirageDrawerStore = create<MirageDrawerSlice>()((...a) => ({
    ...createMirageDrawerSlice(...a),
}));

export const useMirageLoginStore = create<MirageLoginSlice>()((...a) => ({
    ...createMirageLoginSlice(...a),
}));

export const useSessionTimeoutStore = create<SessionTimeoutSlice>()((...a) => ({
    ...createSessionTimeoutSlice(...a),
}));

export const useCustomAlertStore = create<CustomAlertSlice>()((...a) => ({
    ...createCustomAlertSlice(...a),
}));

export const useImageViewerStore = create<ImageViewerSlice>()((...a) => ({
    ...createImageViewerSlice(...a),
}));

export const usePdfReaderStore = create<PdfReaderSlice>()((...a) => ({
    ...createPdfReaderSlice(...a),
}));
